<template>

<!-- Modal -->
<div class="modal fade" :id="idx" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" :aria-labelledby="`${idx}Label`" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" :id="`${idx}Label`">{{ mTitle }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button ref="dismiss" type="button" class="d-none" data-bs-dismiss="modal">Fermer</button>
        <slot name="footer">
          <!-- Default footer content can go here if needed -->
        </slot>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
    name: 'Modal',
    props: {
        mTitle: {
            type: String,
            default: 'Modal title'
        },
        idx: {
            type: String,
            required: true
        },
        dismiss: {
            type: [String, Number],
            default: 0
        }
    },
    watch: {
        dismiss(newVal) {
            if (newVal) {
                this.$refs.dismiss.click();
            }
        }
    },
}
</script>